import { FC } from 'react';
import { IEntry } from 'src/ts/interfaces';
import {
  AssignedRowAppliedCell,
  AssignedRowCheckboxCellStyled,
  AssignedRowContainer,
  AssignedRowDocButton,
  AssignedRowDocCell,
  AssignedRowEmailCell,
  AssignedRowEmptyCell,
  AssignedRowNameCell,
  AssignedRowPhoneCell,
  AssignedRowPropertyCell,
  AssignedRowTextSpan,
  CenteredCheckContainer
} from './styles';

interface AssignedSubmissionRowProps {
  submission: IEntry;
}

const AssignedSubmissionRow: FC<AssignedSubmissionRowProps> = ({ submission }) => {
  const { folder, applicant } = submission;

  const handleDocumentClick = () => {
    if (submission.folder_id) {
      window.open(`/folder/${submission.folder_id}`, '_blank');
    }
  };

  return (
    <AssignedRowContainer>
      <AssignedRowCheckboxCellStyled />

      <AssignedRowNameCell>
        <AssignedRowTextSpan>{applicant?.full_name || 'Unknown'}</AssignedRowTextSpan>
      </AssignedRowNameCell>

      <AssignedRowPropertyCell>
        <AssignedRowTextSpan>{folder?.property?.name || 'Unknown Property'}</AssignedRowTextSpan>
      </AssignedRowPropertyCell>

      <AssignedRowAppliedCell>
        {submission.has_previously_submitted && (
          <CenteredCheckContainer>
            <img src="/assets/images/blueCheck.svg" alt="Applied Before" width="20" height="20" />
          </CenteredCheckContainer>
        )}
      </AssignedRowAppliedCell>

      <AssignedRowEmailCell>
        <AssignedRowTextSpan>{applicant?.email || 'No email'}</AssignedRowTextSpan>
      </AssignedRowEmailCell>

      <AssignedRowPhoneCell>
        <AssignedRowTextSpan>{applicant?.phone || 'No phone'}</AssignedRowTextSpan>
      </AssignedRowPhoneCell>

      <AssignedRowEmptyCell />

      <AssignedRowDocCell>
        <AssignedRowDocButton
          type="button"
          onClick={handleDocumentClick}
          title="Open folder review page"
          aria-label="Open folder review page"
        >
          <img src="/assets/images/doc.svg" alt="" width="24" height="24" />
        </AssignedRowDocButton>
      </AssignedRowDocCell>
    </AssignedRowContainer>
  );
};

export default AssignedSubmissionRow;
